var _defs, _circle, _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottle30Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:blue;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.59,16.36a7.36,7.36,0,0,0-3.15-1.88,6.35,6.35,0,0,1-2.68-1.6l-2.93-3-.31.08a3.69,3.69,0,0,0-2.63,2.65l-.08.3,2.94,2.95a6.46,6.46,0,0,1,1.59,2.69,7.46,7.46,0,0,0,1.86,3.16l4.72,4.74a8.24,8.24,0,0,0,5.39-5.4Zm-.35,8.91L16,21a6.44,6.44,0,0,1-1.59-2.7,7.43,7.43,0,0,0-1.87-3.16l-2.47-2.49a2.58,2.58,0,0,1,1.46-1.47L14,13.66a7.48,7.48,0,0,0,3.15,1.88,6.27,6.27,0,0,1,2.68,1.59l4.26,4.29A6.07,6.07,0,0,1,20.24,25.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.06,21.26l-1,1-1,1L17.45,20.6h0a2.53,2.53,0,0,1,2-2h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.51,8.38l-.89-.9C7.9,6.36,6.34,5.33,5.49,6.23L5,6.69A1.31,1.31,0,0,0,6.28,8.83l.9.91A1.22,1.22,0,0,0,8.51,8.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.88,
    y: 9.96,
    width: 1.1,
    height: 2.11,
    transform: "translate(-5.66 15.05) rotate(-78.17)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.34,
    y: 6.48,
    width: 1.1,
    height: 2.12,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, -1.33, 2.17)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle30Px);
export default __webpack_public_path__ + "static/media/Bottle-30px.1b32a7bdf86ee62145d0d10ebbad3dde.svg";
export { ForwardRef as ReactComponent };